// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Syne:wght@400;700;800&family=DM+Mono:wght@400;500&family=Source+Serif+4:ital,wght@0,400;0,600;0,700;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tutorial5.css - Stoichiometry & Equilibrium Conversion
   Updated with diagrams following Tutorial4 design system
   ============================================================ */

   /* ─── Design tokens ─────────────────────────────────────────────── */
   :root {
     --t5-bg:              #f0f4f2;
     --t5-surface:         #ffffff;
     --t5-panel:           #f5f8f6;
     --t5-card:            #ffffff;
     --t5-sidebar-bg:      #eaf1ee;
     --t5-sidebar-header:  #dfe8e4;
     --t5-code-bg:         #f8faf7;
     --t5-eq-bg:           #f5f9f7;
   
     --t5-accent:          #1b5e3f;
     --t5-accent-dim:      rgba(27, 94, 63, 0.08);
     --t5-accent-glow:     rgba(27, 94, 63, 0.18);
     --t5-accent-hover:    #0f3d28;
   
     --t5-blue:            #2c6b8a;
     --t5-blue-dim:        rgba(44, 107, 138, 0.10);
     --t5-blue-border:     rgba(44, 107, 138, 0.28);
     
     --t5-cyan:            #3a8b96;
     --t5-cyan-dim:        rgba(58, 139, 150, 0.08);
     --t5-cyan-border:     rgba(58, 139, 150, 0.22);
     
     --t5-amber:           #d89f3a;
     --t5-amber-dim:       rgba(216, 159, 58, 0.10);
     --t5-amber-border:    rgba(216, 159, 58, 0.28);
   
     --t5-green-dim:       rgba(27, 94, 63, 0.06);
     --t5-green-border:    rgba(27, 94, 63, 0.20);
   
     --t5-batch:           #d89f3a;
     --t5-cstr:            #2c6b8a;
     --t5-pfr:             #1b5e3f;
     --t5-pbr:             #3a8b96;
   
     --t5-border:          #c5d5ce;
     --t5-border-light:    #dce6e0;
     --t5-border-mid:      #b0c0b7;
   
     --t5-text:            #0f2d1f;
     --t5-text-muted:      #2a3f33;
     --t5-text-mid:        #3a5945;
     --t5-text-dim:        #5a7360;
     --t5-text-sub:        #7a8e80;
   
     --t5-font-mono:   'DM Mono', 'JetBrains Mono', monospace;
     --t5-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;
     --t5-font-brand:  'Syne', sans-serif;
     --t5-font-serif:  'Source Serif 4', Georgia, serif;
   
     --t5-space-xs:  6px;
     --t5-space-sm:  10px;
     --t5-space-md:  16px;
     --t5-space-lg:  24px;
     --t5-space-xl:  40px;
     --t5-space-2xl: 56px;
   
     --t5-radius-sm: 5px;
     --t5-radius-md: 9px;
     --t5-radius-lg: 13px;
   
     --t5-sidebar-w: 260px;
   }
   
   /* ─── Reset ─────────────────────────────────────────────────── */
   *,
   *::before,
   *::after {
     box-sizing: border-box;
     margin: 0;
     padding: 0;
   }
   
   /* ─── Scrollbar ─────────────────────────────────────────────── */
   ::-webkit-scrollbar        { width: 5px; height: 5px; }
   ::-webkit-scrollbar-track  { background: transparent; }
   ::-webkit-scrollbar-thumb  { background: var(--t5-border); border-radius: 3px; }
   ::-webkit-scrollbar-thumb:hover { background: var(--t5-border-mid); }
   
   /* ══════════════════════════════════════════════════════════════
      CONTAINER
   ══════════════════════════════════════════════════════════════ */
   .cre5-container {
     font-family: var(--t5-font-ui);
     background:  var(--t5-bg);
     color:       var(--t5-text);
     display:     flex;
     height:      100%;
     width:       100%;
     font-size:   15px;
     line-height: 1.7;
     overflow:    hidden;
   }
   
   /* ══════════════════════════════════════════════════════════════
      SIDEBAR
   ══════════════════════════════════════════════════════════════ */
   .cre5-sidebar {
     display:        none;
     width:          var(--t5-sidebar-w);
     min-width:      var(--t5-sidebar-w);
     background:     var(--t5-sidebar-bg);
     border-right:   1px solid var(--t5-border);
     height:         100%;
     overflow-y:     auto;
     padding-bottom: 40px;
     font-size:      13px;
     flex-shrink:    0;
   }
   
   @media (min-width: 1600px) {
     .cre5-sidebar { display: block; }
   }
   
   .cre5-sidebar-header {
     background:    var(--t5-sidebar-header);
     padding:       20px 18px 16px;
     border-bottom: 1px solid var(--t5-border);
     position:      sticky;
     top:           0;
     z-index:       10;
   }
   
   .cre5-sidebar-header h1 {
     font-family:    var(--t5-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t5-accent);
     margin-bottom:  4px;
     font-weight:    500;
   }
   
   .cre5-sidebar-header p {
     font-size: 12px;
     color:     var(--t5-text-muted);
   }
   
   .cre5-nav-section {
     padding:        14px 0 4px 18px;
     font-family:    var(--t5-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t5-amber);
     margin-top:     8px;
     font-weight:    500;
   }
   
   .cre5-nav-item {
     display:      block;
     padding:      7px 18px 7px 28px;
     color:        var(--t5-text-muted);
     text-decoration: none;
     border-left:  3px solid transparent;
     transition:   all 0.15s;
     line-height:  1.4;
     cursor:       pointer;
   }
   .cre5-nav-item:hover {
     color:             var(--t5-text);
     background:        var(--t5-accent-dim);
     border-left-color: var(--t5-accent);
   }
   .cre5-nav-item--sub {
     padding-left: 40px;
     font-size:    12px;
     color:        var(--t5-text-dim);
   }
   
   /* ══════════════════════════════════════════════════════════════
      MAIN CONTENT
   ══════════════════════════════════════════════════════════════ */
   .cre5-main {
     flex:       1 1;
     overflow-y: auto;
     overflow-x: hidden;
     min-width:  0;
     animation:  fadeIn5 0.3s ease;
   }
   
   .cre5-main-inner {
     margin:  0 auto;
     padding: 48px 56px 80px;
   }
   
   /* ─── Hero ──────────────────────────────────────────────────── */
   .cre5-hero {
     margin-bottom:  var(--t5-space-2xl);
     padding-bottom: 32px;
     border-bottom:  1px solid var(--t5-border-light);
   }
   
   .cre5-hero-tag {
     font-family:    var(--t5-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 3px;
     color:          var(--t5-amber);
     margin-bottom:  12px;
   }
   
   .cre5-hero h1 {
     font-family:   var(--t5-font-serif);
     font-size:     38px;
     font-weight:   700;
     line-height:   1.2;
     margin-bottom: 12px;
     color:         var(--t5-text);
   }
   
   .cre5-hero-desc {
     color:     var(--t5-text-muted);
     font-size: 16px;
     max-width: 620px;
     line-height: 1.6;
   }
   
   .cre5-hero-meta {
     display:    flex;
     gap:        24px;
     margin-top: 20px;
     flex-wrap:  wrap;
   }
   
   .cre5-meta-item {
     font-family: var(--t5-font-mono);
     font-size:   11px;
     color:       var(--t5-text-dim);
     display:     flex;
     align-items: center;
     gap:         6px;
   }
   
   .cre5-meta-dot {
     width:         6px;
     height:        6px;
     border-radius: 50%;
     background:    var(--t5-accent);
     display:       inline-block;
   }
   
   /* ─── TOC box ───────────────────────────────────────────────── */
   .cre5-toc-box {
     background:    var(--t5-surface);
     border:        1px solid var(--t5-border-light);
     border-top:    3px solid var(--t5-blue);
     border-radius: var(--t5-radius-lg);
     padding:       22px 26px;
     margin-bottom: var(--t5-space-2xl);
   }
   
   .cre5-toc-box h3 {
     font-family:    var(--t5-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t5-text-dim);
     margin-bottom:  14px;
     font-weight:    500;
   }
   
   .cre5-toc-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
     gap:                   6px 20px;
   }
   
   .cre5-toc-link {
     font-size:       13px;
     color:           var(--t5-blue);
     text-decoration: none;
     padding:         4px 0;
     transition:      color 0.15s;
   }
   .cre5-toc-link:hover { color: var(--t5-accent); text-decoration: underline; }
   
   /* ══════════════════════════════════════════════════════════════
      DIAGRAM STYLES
   ══════════════════════════════════════════════════════════════ */
   
   /* ─── Three Building Blocks Diagram ────────────────────────── */
   .cre5-blocks-diagram {
     display: grid;
     grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
     gap: 20px;
     margin: 24px 0;
   }
   
   .cre5-block-card {
     background: var(--t5-surface);
     border-radius: var(--t5-radius-lg);
     padding: 20px;
     text-align: center;
     transition: all 0.3s ease;
     border: 1px solid var(--t5-border-light);
   }
   
   .cre5-block-card:hover {
     transform: translateY(-4px);
     box-shadow: 0 8px 20px rgba(0,0,0,0.08);
   }
   
   .cre5-block-card--mole { border-top: 4px solid var(--t5-amber); }
   .cre5-block-card--rate { border-top: 4px solid var(--t5-blue); }
   .cre5-block-card--stoich { border-top: 4px solid var(--t5-accent); }
   
   .cre5-block-icon {
     font-size: 32px;
     margin-bottom: 12px;
   }
   
   .cre5-block-title {
     font-family: var(--t5-font-serif);
     font-size: 16px;
     font-weight: 600;
     color: var(--t5-text);
     margin-bottom: 8px;
   }
   
   .cre5-block-desc {
     font-size: 12px;
     color: var(--t5-text-dim);
     margin-bottom: 16px;
   }
   
   .cre5-block-equations {
     font-family: var(--t5-font-mono);
     font-size: 11px;
     color: var(--t5-text-mid);
     background: var(--t5-panel);
     padding: 12px;
     border-radius: var(--t5-radius-md);
   }
   
   .cre5-block-equations .katex-display {
     margin: 0.5em 0;
   }
   
   /* ─── Two Steps Diagram ─────────────────────────────────────── */
   .cre5-two-steps-container {
     background: var(--t5-surface);
     border-radius: var(--t5-radius-lg);
     padding: 24px;
     margin: 24px 0;
     border: 1px solid var(--t5-border-light);
   }
   
   .cre5-two-steps-diagram {
     display: flex;
     align-items: center;
     justify-content: space-between;
     gap: 16px;
     flex-wrap: wrap;
   }
   
   .cre5-step-box {
     flex: 1 1;
     min-width: 180px;
     padding: 20px;
     border-radius: var(--t5-radius-md);
     text-align: center;
   }
   
   .cre5-step-box--rate {
     background: var(--t5-cyan-dim);
     border: 2px solid var(--t5-cyan);
   }
   
   .cre5-step-box--stoich {
     background: var(--t5-blue-dim);
     border: 2px solid var(--t5-blue);
   }
   
   .cre5-step-box--combine {
     background: var(--t5-accent-dim);
     border: 2px solid var(--t5-accent);
   }
   
   .cre5-step-box-title {
     font-family: var(--t5-font-mono);
     font-size: 12px;
     font-weight: 600;
     margin-bottom: 12px;
   }
   
   .cre5-step-box--rate .cre5-step-box-title { color: var(--t5-cyan); }
   .cre5-step-box--stoich .cre5-step-box-title { color: var(--t5-blue); }
   .cre5-step-box--combine .cre5-step-box-title { color: var(--t5-accent); }
   
   .cre5-step-box-eq {
     font-family: var(--t5-font-mono);
     font-size: 14px;
     margin: 12px 0;
     padding: 8px;
     background: rgba(255,255,255,0.5);
     border-radius: var(--t5-radius-sm);
   }
   
   .cre5-step-box-desc {
     font-size: 12px;
     color: var(--t5-text-dim);
   }
   
   .cre5-step-arrow {
     font-size: 28px;
     color: var(--t5-text-mid);
     font-weight: bold;
   }
   
   @media (max-width: 700px) {
     .cre5-two-steps-diagram { flex-direction: column; }
     .cre5-step-arrow { transform: rotate(90deg); }
   }
   
   /* ─── Reactors Diagram ──────────────────────────────────────── */
   .cre5-reactors-diagram {
     display: flex;
     justify-content: center;
     gap: 32px;
     margin: 24px 0;
     padding: 20px;
     background: var(--t5-surface);
     border-radius: var(--t5-radius-lg);
     border: 1px solid var(--t5-border-light);
     flex-wrap: wrap;
   }
   
   .cre5-reactor-icon {
     text-align: center;
   }
   
   .cre5-reactor-icon svg {
     display: block;
     margin: 0 auto;
   }
   
   /* ─── Arrhenius Plot ────────────────────────────────────────── */
   .cre5-arrhenius-container {
     background: var(--t5-surface);
     border-radius: var(--t5-radius-lg);
     padding: 24px;
     margin: 24px 0;
     border: 1px solid var(--t5-border-light);
   }
   
   .cre5-arrhenius-title {
     font-family: var(--t5-font-mono);
     font-size: 11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color: var(--t5-text-dim);
     margin-bottom: 16px;
     text-align: center;
   }
   
   .cre5-arrhenius-svg {
     width: 100%;
     max-width: 500px;
     display: block;
     margin: 0 auto;
   }
   
   .cre5-arrhenius-caption {
     font-size: 12px;
     color: var(--t5-text-sub);
     text-align: center;
     margin-top: 14px;
     font-style: italic;
   }
   
   /* ─── Stoichiometry Table Visual ─────────────────────────────── */
   .cre5-stoich-table-visual {
     background: var(--t5-surface);
     border-radius: var(--t5-radius-lg);
     border: 1px solid var(--t5-border);
     overflow: hidden;
     margin: 24px 0;
   }
   
   .cre5-stoich-row {
     display: grid;
     grid-template-columns: 80px 1fr 1fr 1.5fr;
     border-bottom: 1px solid var(--t5-border-light);
   }
   
   .cre5-stoich-row > span {
     padding: 12px 16px;
     font-size: 13px;
   }
   
   .cre5-stoich-header {
     background: var(--t5-panel);
     font-family: var(--t5-font-mono);
     font-size: 10px;
     text-transform: uppercase;
     letter-spacing: 1px;
     font-weight: 600;
     color: var(--t5-text-dim);
   }
   
   .cre5-stoich-header > span {
     padding: 10px 16px;
   }
   
   .cre5-stoich-species {
     font-family: var(--t5-font-mono);
     font-weight: 600;
     color: var(--t5-text-mid);
   }
   
   .cre5-stoich-result {
     font-family: var(--t5-font-mono);
     color: var(--t5-accent);
     font-weight: 500;
   }
   
   .cre5-stoich-total {
     background: var(--t5-accent-dim);
     border-top: 1px solid var(--t5-border);
   }
   
   @media (max-width: 800px) {
     .cre5-stoich-row {
       grid-template-columns: 60px 1fr 1fr 1fr;
       font-size: 11px;
     }
     .cre5-stoich-row > span { padding: 8px 12px; }
   }
   
   /* ─── Table styles ──────────────────────────────────────────── */
   .cre5-table {
     width: 100%;
     border-collapse: collapse;
     margin: 16px 0;
     font-size: 13px;
     background: var(--t5-surface);
     border-radius: var(--t5-radius-md);
     overflow: hidden;
     border: 1px solid var(--t5-border-light);
   }
   
   .cre5-table thead {
     background: var(--t5-panel);
   }
   
   .cre5-table th {
     padding: 11px 14px;
     text-align: left;
     font-family: var(--t5-font-mono);
     font-size: 10px;
     text-transform: uppercase;
     letter-spacing: 1.5px;
     color: var(--t5-text-dim);
     border-bottom: 1px solid var(--t5-border);
     font-weight: 600;
   }
   
   .cre5-table td {
     padding: 12px 14px;
     border-bottom: 1px solid var(--t5-border-light);
     color: var(--t5-text-muted);
     vertical-align: top;
   }
   
   .cre5-symbols-table {
     width: 100%;
     border-collapse: collapse;
     margin: 20px 0;
     font-size: 13px;
     background: var(--t5-surface);
     border-radius: var(--t5-radius-md);
     overflow: hidden;
     border: 1px solid var(--t5-border-light);
   }
   
   .cre5-symbols-table thead {
     background: var(--t5-panel);
   }
   
   .cre5-symbols-table th {
     padding: 11px 14px;
     text-align: left;
     font-family: var(--t5-font-mono);
     font-size: 10px;
     text-transform: uppercase;
     letter-spacing: 1.5px;
     color: var(--t5-text-dim);
     border-bottom: 1px solid var(--t5-border);
     font-weight: 600;
   }
   
   .cre5-symbols-table td {
     padding: 12px 14px;
     border-bottom: 1px solid var(--t5-border-light);
     color: var(--t5-text-muted);
   }
   
   /* ─── Definition cards ──────────────────────────────────────── */
   .cre5-definitions-grid {
     display: grid;
     grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
     gap: 16px;
     margin-top: 20px;
   }
   
   .cre5-def-card {
     background: var(--t5-surface);
     border: 1px solid var(--t5-border);
     border-radius: var(--t5-radius-md);
     padding: 16px;
     transition: all 0.2s ease;
   }
   
   .cre5-def-card:hover {
     box-shadow: 0 2px 8px rgba(0,0,0,0.06);
   }
   
   .cre5-def-title {
     font-family: var(--t5-font-serif);
     font-size: 13px;
     font-weight: 600;
     color: var(--t5-text);
     margin-bottom: 10px;
   }
   
   /* ─── Callout boxes ─────────────────────────────────────────── */
   .cre5-callout {
     border-radius: var(--t5-radius-md);
     padding:       14px 18px;
     margin:        18px 0;
     font-size:     14px;
     line-height:   1.65;
   }
   .cre5-callout p  { color: var(--t5-text-muted); margin: 0; }
   .cre5-callout--key  { background: var(--t5-blue-dim);  border: 1px solid var(--t5-blue-border);  }
   .cre5-callout--info { background: var(--t5-cyan-dim);  border: 1px solid var(--t5-cyan-border);  }
   .cre5-callout--rate { background: var(--t5-blue-dim); border: 1px solid var(--t5-blue-border); }
   
   /* ─── Equation boxes ────────────────────────────────────────── */
   .cre5-equation-box {
     background:    var(--t5-eq-bg);
     border:        1px solid var(--t5-border-light);
     border-left:   3px solid var(--t5-amber);
     border-radius: var(--t5-radius-md);
     padding:       18px 22px;
     margin:        18px 0;
     overflow-x:    auto;
   }
   
   .cre5-equation-box--primary {
     border-left-color: var(--t5-accent);
   }
   
   .cre5-equation-box--flow {
     border-left-color: var(--t5-blue);
   }
   
   .cre5-equation-box--gas {
     border-left-color: var(--t5-cyan);
   }
   
   .cre5-equation-box--compare {
     border-left-color: var(--t5-amber);
   }
   
   .cre5-eq-label {
     font-size:      10px;
     font-family:    var(--t5-font-mono);
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t5-text-dim);
     margin-bottom:  8px;
   }
   
   /* ─── Example box ───────────────────────────────────────────── */
   .cre5-example-box {
     background: var(--t5-surface);
     border: 1px solid var(--t5-border);
     border-radius: var(--t5-radius-md);
     padding: 20px;
     margin: 16px 0;
   }
   
   .cre5-example-header {
     font-family: var(--t5-font-serif);
     font-size: 14px;
     font-weight: 600;
     color: var(--t5-text);
     padding-bottom: 12px;
     border-bottom: 1px solid var(--t5-border-light);
   }
   
   /* ─── Reactor cards ─────────────────────────────────────────── */
   .cre5-reactor-cards {
     display: grid;
     grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
     gap: 20px;
     margin-top: 20px;
   }
   
   .cre5-reactor-card {
     background: var(--t5-surface);
     border: 1px solid var(--t5-border);
     border-radius: var(--t5-radius-md);
     padding: 16px;
     transition: all 0.2s ease;
   }
   
   .cre5-reactor-card:hover {
     box-shadow: 0 4px 12px rgba(0,0,0,0.08);
   }
   
   .cre5-reactor-card--batch {
     border-top: 3px solid var(--t5-batch);
   }
   
   .cre5-reactor-card--cstr {
     border-top: 3px solid var(--t5-cstr);
   }
   
   .cre5-reactor-card--pfr {
     border-top: 3px solid var(--t5-pfr);
   }
   
   .cre5-reactor-card--pbr {
     border-top: 3px solid var(--t5-pbr);
   }
   
   .cre5-card-title {
     font-family: var(--t5-font-serif);
     font-size: 14px;
     font-weight: 600;
     color: var(--t5-text);
     margin-bottom: 12px;
   }
   
   .cre5-card-eq {
     background: var(--t5-panel);
     padding: 12px;
     border-radius: var(--t5-radius-sm);
     margin-bottom: 12px;
     font-size: 12px;
   }
   
   .cre5-card-info {
     font-size: 12px;
     color: var(--t5-text-muted);
   }
   
   .cre5-card-info ul {
     margin-left: 16px;
     margin-top: 8px;
   }
   
   .cre5-card-info li {
     margin-bottom: 6px;
     line-height: 1.5;
   }
   
   /* ─── Section styles ────────────────────────────────────────── */
   .cre5-section {
     margin-bottom: var(--t5-space-2xl);
     scroll-margin-top: 24px;
   }
   
   .cre5-section-label {
     font-family:    var(--t5-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2.5px;
     color:          var(--t5-text-sub);
     margin-bottom:  6px;
   }
   
   .cre5-section h2 {
     font-family:   var(--t5-font-serif);
     font-size:     26px;
     font-weight:   700;
     color:         var(--t5-text);
     margin-bottom: 6px;
     line-height:   1.3;
   }
   
   .cre5-section-divider {
     width:         40px;
     height:        3px;
     background:    var(--t5-accent);
     margin-bottom: 22px;
     border-radius: 2px;
   }
   
   .cre5-section p {
     margin-bottom: 14px;
     color:         var(--t5-text-muted);
     line-height:   1.75;
   }
   
   /* ─── Badges ────────────────────────────────────────────────── */
   .cre5-lec-badge {
     display:        inline-block;
     font-family:    var(--t5-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2px;
     padding:        3px 9px;
     border-radius:  var(--t5-radius-sm);
     margin-bottom:  10px;
     font-weight:    500;
   }
   
   .cre5-lec-badge--foundation {
     background: var(--t5-green-dim);
     color:      var(--t5-accent);
     border:     1px solid var(--t5-green-border);
   }
   .cre5-lec-badge--block1 {
     background: rgba(216, 159, 58, 0.10);
     color:      var(--t5-amber);
     border:     1px solid var(--t5-amber-border);
   }
   .cre5-lec-badge--block2 {
     background: var(--t5-cyan-dim);
     color:      var(--t5-cyan);
     border:     1px solid var(--t5-cyan-border);
   }
   .cre5-lec-badge--block3 {
     background: var(--t5-blue-dim);
     color:      var(--t5-blue);
     border:     1px solid var(--t5-blue-border);
   }
   .cre5-lec-badge--equilibrium {
     background: var(--t5-accent-dim);
     color:      var(--t5-accent);
     border:     1px solid var(--t5-green-border);
   }
   
   /* ─── Footer ────────────────────────────────────────────────── */
   .cre5-footer {
     border-top:  1px solid var(--t5-border-light);
     padding-top: 24px;
     margin-top:  40px;
     color:       var(--t5-text-dim);
     font-family: var(--t5-font-mono);
     font-size:   11px;
     text-align: center;
   }
   
   /* ─── Animation ─────────────────────────────────────────────── */
   @keyframes fadeIn5 {
     from { opacity: 0; transform: translateY(4px); }
     to   { opacity: 1; transform: translateY(0); }
   }
   
   /* ─── Katex overrides ───────────────────────────────────────── */
   .katex { font-size: 1.05em; }
   .katex-display { margin: 0.8em 0; overflow-x: auto; overflow-y: hidden; }
   
   /* ─── Responsive ────────────────────────────────────────────── */
   @media (max-width: 1200px) {
     .cre5-main-inner { padding: 36px 36px 60px; }
   }
   
   @media (max-width: 900px) {
     .cre5-sidebar { display: none !important; }
     .cre5-main-inner { padding: 24px 20px 60px; }
     .cre5-toc-grid { grid-template-columns: 1fr 1fr; }
     .cre5-blocks-diagram { grid-template-columns: 1fr; }
   }
   
   @media (max-width: 600px) {
     .cre5-hero h1 { font-size: 26px; }
     .cre5-toc-grid { grid-template-columns: 1fr; }
     .cre5-definitions-grid { grid-template-columns: 1fr; }
     .cre5-reactor-cards { grid-template-columns: 1fr; }
     .cre5-reactors-diagram { gap: 16px; }
   }`, "",{"version":3,"sources":["webpack://./src/styles/Tutorial5.css"],"names":[],"mappings":"AAAA;;iEAEiE;;GAI9D,sEAAsE;GACtE;KACE,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,4CAA4C;KAC5C,4CAA4C;KAC5C,6BAA6B;;KAE7B,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;;KAE9C,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;;KAE9C,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;;KAE9C,4CAA4C;KAC5C,4CAA4C;;KAE5C,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,wDAAwD;KACxD,8DAA8D;KAC9D,oCAAoC;KACpC,kDAAkD;;KAElD,mBAAmB;KACnB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;;KAEpB,mBAAmB;KACnB,mBAAmB;KACnB,oBAAoB;;KAEpB,qBAAqB;GACvB;;GAEA,kEAAkE;GAClE;;;KAGE,sBAAsB;KACtB,SAAS;KACT,UAAU;GACZ;;GAEA,kEAAkE;GAClE,6BAA6B,UAAU,EAAE,WAAW,EAAE;GACtD,6BAA6B,uBAAuB,EAAE;GACtD,6BAA6B,4BAA4B,EAAE,kBAAkB,EAAE;GAC/E,kCAAkC,gCAAgC,EAAE;;GAEpE;;mEAEgE;GAChE;KACE,8BAA8B;KAC9B,yBAAyB;KACzB,2BAA2B;KAC3B,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;;mEAEgE;GAChE;KACE,oBAAoB;KACpB,mCAAmC;KACnC,mCAAmC;KACnC,oCAAoC;KACpC,0CAA0C;KAC1C,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,iBAAiB;GACnB;;GAEA;KACE,gBAAgB,cAAc,EAAE;GAClC;;GAEA;KACE,uCAAuC;KACvC,6BAA6B;KAC7B,yCAAyC;KACzC,qBAAqB;KACrB,gBAAgB;KAChB,iBAAiB;GACnB;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,gCAAgC;KAChC,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,+BAA+B;GACjC;;GAEA;KACE,+BAA+B;KAC/B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;KACnB,+BAA+B;KAC/B,kCAAkC;KAClC,qBAAqB;KACrB,mCAAmC;KACnC,uBAAuB;KACvB,iBAAiB;KACjB,qBAAqB;GACvB;GACA;KACE,iCAAiC;KACjC,uCAAuC;KACvC,mCAAmC;GACrC;GACA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,gCAAgC;GAClC;;GAEA;;mEAEgE;GAChE;KACE,eAAa;KACb,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;KACb,6BAA6B;GAC/B;;GAEA;KACE,eAAe;KACf,uBAAuB;GACzB;;GAEA,kEAAkE;GAClE;KACE,mCAAmC;KACnC,oBAAoB;KACpB,gDAAgD;GAClD;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,oBAAoB;GACtB;;GAEA;KACE,mCAAmC;KACnC,mBAAmB;KACnB,kBAAkB;KAClB,kBAAkB;KAClB,mBAAmB;KACnB,6BAA6B;GAC/B;;GAEA;KACE,+BAA+B;KAC/B,eAAe;KACf,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA;KACE,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,+BAA+B;KAC/B,iBAAiB;KACjB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;KAClB,+BAA+B;KAC/B,2BAA2B;GAC7B;;GAEA,kEAAkE;GAClE;KACE,gCAAgC;KAChC,+CAA+C;KAC/C,uCAAuC;KACvC,kCAAkC;KAClC,wBAAwB;KACxB,kCAAkC;GACpC;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,kCAAkC;KAClC,oBAAoB;KACpB,mBAAmB;GACrB;;GAEA;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,+BAA+B;GACjC;;GAEA;KACE,qBAAqB;KACrB,+BAA+B;KAC/B,qBAAqB;KACrB,sBAAsB;KACtB,4BAA4B;GAC9B;GACA,uBAAuB,uBAAuB,EAAE,0BAA0B,EAAE;;GAE5E;;mEAEgE;;GAEhE,iEAAiE;GACjE;KACE,aAAa;KACb,2DAA2D;KAC3D,SAAS;KACT,cAAc;GAChB;;GAEA;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,aAAa;KACb,kBAAkB;KAClB,yBAAyB;KACzB,wCAAwC;GAC1C;;GAEA;KACE,2BAA2B;KAC3B,uCAAuC;GACzC;;GAEA,yBAAyB,qCAAqC,EAAE;GAChE,yBAAyB,oCAAoC,EAAE;GAC/D,2BAA2B,sCAAsC,EAAE;;GAEnE;KACE,eAAe;KACf,mBAAmB;GACrB;;GAEA;KACE,iCAAiC;KACjC,eAAe;KACf,gBAAgB;KAChB,qBAAqB;KACrB,kBAAkB;GACpB;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,mBAAmB;GACrB;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,2BAA2B;KAC3B,aAAa;KACb,kCAAkC;GACpC;;GAEA;KACE,eAAe;GACjB;;GAEA,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,aAAa;KACb,cAAc;KACd,wCAAwC;GAC1C;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,SAAS;KACT,eAAe;GACjB;;GAEA;KACE,SAAO;KACP,gBAAgB;KAChB,aAAa;KACb,kCAAkC;KAClC,kBAAkB;GACpB;;GAEA;KACE,8BAA8B;KAC9B,gCAAgC;GAClC;;GAEA;KACE,8BAA8B;KAC9B,gCAAgC;GAClC;;GAEA;KACE,gCAAgC;KAChC,kCAAkC;GACpC;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA,4CAA4C,qBAAqB,EAAE;GACnE,8CAA8C,qBAAqB,EAAE;GACrE,+CAA+C,uBAAuB,EAAE;;GAExE;KACE,gCAAgC;KAChC,eAAe;KACf,cAAc;KACd,YAAY;KACZ,iCAAiC;KACjC,kCAAkC;GACpC;;GAEA;KACE,eAAe;KACf,yBAAyB;GAC3B;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,iBAAiB;GACnB;;GAEA;KACE,0BAA0B,sBAAsB,EAAE;KAClD,mBAAmB,wBAAwB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE;KACE,aAAa;KACb,uBAAuB;KACvB,SAAS;KACT,cAAc;KACd,aAAa;KACb,6BAA6B;KAC7B,kCAAkC;KAClC,wCAAwC;KACxC,eAAe;GACjB;;GAEA;KACE,kBAAkB;GACpB;;GAEA;KACE,cAAc;KACd,cAAc;GAChB;;GAEA,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,aAAa;KACb,cAAc;KACd,wCAAwC;GAC1C;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA;KACE,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,cAAc;GAChB;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,kBAAkB;KAClB,gBAAgB;KAChB,kBAAkB;GACpB;;GAEA,mEAAmE;GACnE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,kCAAkC;KAClC,gBAAgB;KAChB,cAAc;GAChB;;GAEA;KACE,aAAa;KACb,yCAAyC;KACzC,+CAA+C;GACjD;;GAEA;KACE,kBAAkB;KAClB,eAAe;GACjB;;GAEA;KACE,2BAA2B;KAC3B,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,mBAAmB;KACnB,gBAAgB;KAChB,yBAAyB;GAC3B;;GAEA;KACE,kBAAkB;GACpB;;GAEA;KACE,gCAAgC;KAChC,gBAAgB;KAChB,yBAAyB;GAC3B;;GAEA;KACE,gCAAgC;KAChC,uBAAuB;KACvB,gBAAgB;GAClB;;GAEA;KACE,gCAAgC;KAChC,sCAAsC;GACxC;;GAEA;KACE;OACE,uCAAuC;OACvC,eAAe;KACjB;KACA,0BAA0B,iBAAiB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE;KACE,WAAW;KACX,yBAAyB;KACzB,cAAc;KACd,eAAe;KACf,6BAA6B;KAC7B,kCAAkC;KAClC,gBAAgB;KAChB,wCAAwC;GAC1C;;GAEA;KACE,2BAA2B;GAC7B;;GAEA;KACE,kBAAkB;KAClB,gBAAgB;KAChB,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,qBAAqB;KACrB,yBAAyB;KACzB,yCAAyC;KACzC,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,+CAA+C;KAC/C,2BAA2B;KAC3B,mBAAmB;GACrB;;GAEA;KACE,WAAW;KACX,yBAAyB;KACzB,cAAc;KACd,eAAe;KACf,6BAA6B;KAC7B,kCAAkC;KAClC,gBAAgB;KAChB,wCAAwC;GAC1C;;GAEA;KACE,2BAA2B;GAC7B;;GAEA;KACE,kBAAkB;KAClB,gBAAgB;KAChB,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,qBAAqB;KACrB,yBAAyB;KACzB,yCAAyC;KACzC,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,+CAA+C;KAC/C,2BAA2B;GAC7B;;GAEA,kEAAkE;GAClE;KACE,aAAa;KACb,2DAA2D;KAC3D,SAAS;KACT,gBAAgB;GAClB;;GAEA;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,kCAAkC;KAClC,aAAa;KACb,yBAAyB;GAC3B;;GAEA;KACE,sCAAsC;GACxC;;GAEA;KACE,iCAAiC;KACjC,eAAe;KACf,gBAAgB;KAChB,qBAAqB;KACrB,mBAAmB;GACrB;;GAEA,kEAAkE;GAClE;KACE,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;KACnB,mBAAmB;GACrB;GACA,mBAAmB,2BAA2B,EAAE,SAAS,EAAE;GAC3D,sBAAsB,8BAA8B,GAAG,uCAAuC,GAAG;GACjG,sBAAsB,8BAA8B,GAAG,uCAAuC,GAAG;GACjG,sBAAsB,8BAA8B,EAAE,uCAAuC,EAAE;;GAE/F,kEAAkE;GAClE;KACE,8BAA8B;KAC9B,+CAA+C;KAC/C,wCAAwC;KACxC,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;GACrB;;GAEA;KACE,mCAAmC;GACrC;;GAEA;KACE,iCAAiC;GACnC;;GAEA;KACE,iCAAiC;GACnC;;GAEA;KACE,kCAAkC;GACpC;;GAEA;KACE,oBAAoB;KACpB,mCAAmC;KACnC,yBAAyB;KACzB,mBAAmB;KACnB,kCAAkC;KAClC,mBAAmB;GACrB;;GAEA,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,kCAAkC;KAClC,aAAa;KACb,cAAc;GAChB;;GAEA;KACE,iCAAiC;KACjC,eAAe;KACf,gBAAgB;KAChB,qBAAqB;KACrB,oBAAoB;KACpB,+CAA+C;GACjD;;GAEA,kEAAkE;GAClE;KACE,aAAa;KACb,2DAA2D;KAC3D,SAAS;KACT,gBAAgB;GAClB;;GAEA;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,kCAAkC;KAClC,aAAa;KACb,yBAAyB;GAC3B;;GAEA;KACE,uCAAuC;GACzC;;GAEA;KACE,qCAAqC;GACvC;;GAEA;KACE,oCAAoC;GACtC;;GAEA;KACE,mCAAmC;GACrC;;GAEA;KACE,mCAAmC;GACrC;;GAEA;KACE,iCAAiC;KACjC,eAAe;KACf,gBAAgB;KAChB,qBAAqB;KACrB,mBAAmB;GACrB;;GAEA;KACE,2BAA2B;KAC3B,aAAa;KACb,kCAAkC;KAClC,mBAAmB;KACnB,eAAe;GACjB;;GAEA;KACE,eAAe;KACf,2BAA2B;GAC7B;;GAEA;KACE,iBAAiB;KACjB,eAAe;GACjB;;GAEA;KACE,kBAAkB;KAClB,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,kCAAkC;KAClC,uBAAuB;GACzB;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,qBAAqB;KACrB,kCAAkC;KAClC,mBAAmB;GACrB;;GAEA;KACE,mCAAmC;KACnC,mBAAmB;KACnB,kBAAkB;KAClB,6BAA6B;KAC7B,kBAAkB;KAClB,kBAAkB;GACpB;;GAEA;KACE,mBAAmB;KACnB,kBAAkB;KAClB,+BAA+B;KAC/B,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA;KACE,mBAAmB;KACnB,mCAAmC;KACnC,mBAAmB;GACrB;;GAEA,kEAAkE;GAClE;KACE,4BAA4B;KAC5B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,uBAAuB;KACvB,mCAAmC;KACnC,oBAAoB;KACpB,mBAAmB;GACrB;;GAEA;KACE,+BAA+B;KAC/B,4BAA4B;KAC5B,4CAA4C;GAC9C;GACA;KACE,oCAAoC;KACpC,2BAA2B;KAC3B,4CAA4C;GAC9C;GACA;KACE,8BAA8B;KAC9B,0BAA0B;KAC1B,2CAA2C;GAC7C;GACA;KACE,8BAA8B;KAC9B,0BAA0B;KAC1B,2CAA2C;GAC7C;GACA;KACE,gCAAgC;KAChC,4BAA4B;KAC5B,4CAA4C;GAC9C;;GAEA,kEAAkE;GAClE;KACE,6CAA6C;KAC7C,iBAAiB;KACjB,iBAAiB;KACjB,+BAA+B;KAC/B,gCAAgC;KAChC,iBAAiB;KACjB,kBAAkB;GACpB;;GAEA,kEAAkE;GAClE;KACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;KAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE,SAAS,iBAAiB,EAAE;GAC5B,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;GAExE,kEAAkE;GAClE;KACE,mBAAmB,uBAAuB,EAAE;GAC9C;;GAEA;KACE,gBAAgB,wBAAwB,EAAE;KAC1C,mBAAmB,uBAAuB,EAAE;KAC5C,iBAAiB,8BAA8B,EAAE;KACjD,uBAAuB,0BAA0B,EAAE;GACrD;;GAEA;KACE,gBAAgB,eAAe,EAAE;KACjC,iBAAiB,0BAA0B,EAAE;KAC7C,yBAAyB,0BAA0B,EAAE;KACrD,sBAAsB,0BAA0B,EAAE;KAClD,yBAAyB,SAAS,EAAE;GACtC","sourcesContent":["/* Tutorial5.css - Stoichiometry & Equilibrium Conversion\n   Updated with diagrams following Tutorial4 design system\n   ============================================================ */\n\n   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Syne:wght@400;700;800&family=DM+Mono:wght@400;500&family=Source+Serif+4:ital,wght@0,400;0,600;0,700;1,400&display=swap');\n\n   /* ─── Design tokens ─────────────────────────────────────────────── */\n   :root {\n     --t5-bg:              #f0f4f2;\n     --t5-surface:         #ffffff;\n     --t5-panel:           #f5f8f6;\n     --t5-card:            #ffffff;\n     --t5-sidebar-bg:      #eaf1ee;\n     --t5-sidebar-header:  #dfe8e4;\n     --t5-code-bg:         #f8faf7;\n     --t5-eq-bg:           #f5f9f7;\n   \n     --t5-accent:          #1b5e3f;\n     --t5-accent-dim:      rgba(27, 94, 63, 0.08);\n     --t5-accent-glow:     rgba(27, 94, 63, 0.18);\n     --t5-accent-hover:    #0f3d28;\n   \n     --t5-blue:            #2c6b8a;\n     --t5-blue-dim:        rgba(44, 107, 138, 0.10);\n     --t5-blue-border:     rgba(44, 107, 138, 0.28);\n     \n     --t5-cyan:            #3a8b96;\n     --t5-cyan-dim:        rgba(58, 139, 150, 0.08);\n     --t5-cyan-border:     rgba(58, 139, 150, 0.22);\n     \n     --t5-amber:           #d89f3a;\n     --t5-amber-dim:       rgba(216, 159, 58, 0.10);\n     --t5-amber-border:    rgba(216, 159, 58, 0.28);\n   \n     --t5-green-dim:       rgba(27, 94, 63, 0.06);\n     --t5-green-border:    rgba(27, 94, 63, 0.20);\n   \n     --t5-batch:           #d89f3a;\n     --t5-cstr:            #2c6b8a;\n     --t5-pfr:             #1b5e3f;\n     --t5-pbr:             #3a8b96;\n   \n     --t5-border:          #c5d5ce;\n     --t5-border-light:    #dce6e0;\n     --t5-border-mid:      #b0c0b7;\n   \n     --t5-text:            #0f2d1f;\n     --t5-text-muted:      #2a3f33;\n     --t5-text-mid:        #3a5945;\n     --t5-text-dim:        #5a7360;\n     --t5-text-sub:        #7a8e80;\n   \n     --t5-font-mono:   'DM Mono', 'JetBrains Mono', monospace;\n     --t5-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;\n     --t5-font-brand:  'Syne', sans-serif;\n     --t5-font-serif:  'Source Serif 4', Georgia, serif;\n   \n     --t5-space-xs:  6px;\n     --t5-space-sm:  10px;\n     --t5-space-md:  16px;\n     --t5-space-lg:  24px;\n     --t5-space-xl:  40px;\n     --t5-space-2xl: 56px;\n   \n     --t5-radius-sm: 5px;\n     --t5-radius-md: 9px;\n     --t5-radius-lg: 13px;\n   \n     --t5-sidebar-w: 260px;\n   }\n   \n   /* ─── Reset ─────────────────────────────────────────────────── */\n   *,\n   *::before,\n   *::after {\n     box-sizing: border-box;\n     margin: 0;\n     padding: 0;\n   }\n   \n   /* ─── Scrollbar ─────────────────────────────────────────────── */\n   ::-webkit-scrollbar        { width: 5px; height: 5px; }\n   ::-webkit-scrollbar-track  { background: transparent; }\n   ::-webkit-scrollbar-thumb  { background: var(--t5-border); border-radius: 3px; }\n   ::-webkit-scrollbar-thumb:hover { background: var(--t5-border-mid); }\n   \n   /* ══════════════════════════════════════════════════════════════\n      CONTAINER\n   ══════════════════════════════════════════════════════════════ */\n   .cre5-container {\n     font-family: var(--t5-font-ui);\n     background:  var(--t5-bg);\n     color:       var(--t5-text);\n     display:     flex;\n     height:      100%;\n     width:       100%;\n     font-size:   15px;\n     line-height: 1.7;\n     overflow:    hidden;\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      SIDEBAR\n   ══════════════════════════════════════════════════════════════ */\n   .cre5-sidebar {\n     display:        none;\n     width:          var(--t5-sidebar-w);\n     min-width:      var(--t5-sidebar-w);\n     background:     var(--t5-sidebar-bg);\n     border-right:   1px solid var(--t5-border);\n     height:         100%;\n     overflow-y:     auto;\n     padding-bottom: 40px;\n     font-size:      13px;\n     flex-shrink:    0;\n   }\n   \n   @media (min-width: 1600px) {\n     .cre5-sidebar { display: block; }\n   }\n   \n   .cre5-sidebar-header {\n     background:    var(--t5-sidebar-header);\n     padding:       20px 18px 16px;\n     border-bottom: 1px solid var(--t5-border);\n     position:      sticky;\n     top:           0;\n     z-index:       10;\n   }\n   \n   .cre5-sidebar-header h1 {\n     font-family:    var(--t5-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t5-accent);\n     margin-bottom:  4px;\n     font-weight:    500;\n   }\n   \n   .cre5-sidebar-header p {\n     font-size: 12px;\n     color:     var(--t5-text-muted);\n   }\n   \n   .cre5-nav-section {\n     padding:        14px 0 4px 18px;\n     font-family:    var(--t5-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t5-amber);\n     margin-top:     8px;\n     font-weight:    500;\n   }\n   \n   .cre5-nav-item {\n     display:      block;\n     padding:      7px 18px 7px 28px;\n     color:        var(--t5-text-muted);\n     text-decoration: none;\n     border-left:  3px solid transparent;\n     transition:   all 0.15s;\n     line-height:  1.4;\n     cursor:       pointer;\n   }\n   .cre5-nav-item:hover {\n     color:             var(--t5-text);\n     background:        var(--t5-accent-dim);\n     border-left-color: var(--t5-accent);\n   }\n   .cre5-nav-item--sub {\n     padding-left: 40px;\n     font-size:    12px;\n     color:        var(--t5-text-dim);\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      MAIN CONTENT\n   ══════════════════════════════════════════════════════════════ */\n   .cre5-main {\n     flex:       1;\n     overflow-y: auto;\n     overflow-x: hidden;\n     min-width:  0;\n     animation:  fadeIn5 0.3s ease;\n   }\n   \n   .cre5-main-inner {\n     margin:  0 auto;\n     padding: 48px 56px 80px;\n   }\n   \n   /* ─── Hero ──────────────────────────────────────────────────── */\n   .cre5-hero {\n     margin-bottom:  var(--t5-space-2xl);\n     padding-bottom: 32px;\n     border-bottom:  1px solid var(--t5-border-light);\n   }\n   \n   .cre5-hero-tag {\n     font-family:    var(--t5-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 3px;\n     color:          var(--t5-amber);\n     margin-bottom:  12px;\n   }\n   \n   .cre5-hero h1 {\n     font-family:   var(--t5-font-serif);\n     font-size:     38px;\n     font-weight:   700;\n     line-height:   1.2;\n     margin-bottom: 12px;\n     color:         var(--t5-text);\n   }\n   \n   .cre5-hero-desc {\n     color:     var(--t5-text-muted);\n     font-size: 16px;\n     max-width: 620px;\n     line-height: 1.6;\n   }\n   \n   .cre5-hero-meta {\n     display:    flex;\n     gap:        24px;\n     margin-top: 20px;\n     flex-wrap:  wrap;\n   }\n   \n   .cre5-meta-item {\n     font-family: var(--t5-font-mono);\n     font-size:   11px;\n     color:       var(--t5-text-dim);\n     display:     flex;\n     align-items: center;\n     gap:         6px;\n   }\n   \n   .cre5-meta-dot {\n     width:         6px;\n     height:        6px;\n     border-radius: 50%;\n     background:    var(--t5-accent);\n     display:       inline-block;\n   }\n   \n   /* ─── TOC box ───────────────────────────────────────────────── */\n   .cre5-toc-box {\n     background:    var(--t5-surface);\n     border:        1px solid var(--t5-border-light);\n     border-top:    3px solid var(--t5-blue);\n     border-radius: var(--t5-radius-lg);\n     padding:       22px 26px;\n     margin-bottom: var(--t5-space-2xl);\n   }\n   \n   .cre5-toc-box h3 {\n     font-family:    var(--t5-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t5-text-dim);\n     margin-bottom:  14px;\n     font-weight:    500;\n   }\n   \n   .cre5-toc-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n     gap:                   6px 20px;\n   }\n   \n   .cre5-toc-link {\n     font-size:       13px;\n     color:           var(--t5-blue);\n     text-decoration: none;\n     padding:         4px 0;\n     transition:      color 0.15s;\n   }\n   .cre5-toc-link:hover { color: var(--t5-accent); text-decoration: underline; }\n   \n   /* ══════════════════════════════════════════════════════════════\n      DIAGRAM STYLES\n   ══════════════════════════════════════════════════════════════ */\n   \n   /* ─── Three Building Blocks Diagram ────────────────────────── */\n   .cre5-blocks-diagram {\n     display: grid;\n     grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n     gap: 20px;\n     margin: 24px 0;\n   }\n   \n   .cre5-block-card {\n     background: var(--t5-surface);\n     border-radius: var(--t5-radius-lg);\n     padding: 20px;\n     text-align: center;\n     transition: all 0.3s ease;\n     border: 1px solid var(--t5-border-light);\n   }\n   \n   .cre5-block-card:hover {\n     transform: translateY(-4px);\n     box-shadow: 0 8px 20px rgba(0,0,0,0.08);\n   }\n   \n   .cre5-block-card--mole { border-top: 4px solid var(--t5-amber); }\n   .cre5-block-card--rate { border-top: 4px solid var(--t5-blue); }\n   .cre5-block-card--stoich { border-top: 4px solid var(--t5-accent); }\n   \n   .cre5-block-icon {\n     font-size: 32px;\n     margin-bottom: 12px;\n   }\n   \n   .cre5-block-title {\n     font-family: var(--t5-font-serif);\n     font-size: 16px;\n     font-weight: 600;\n     color: var(--t5-text);\n     margin-bottom: 8px;\n   }\n   \n   .cre5-block-desc {\n     font-size: 12px;\n     color: var(--t5-text-dim);\n     margin-bottom: 16px;\n   }\n   \n   .cre5-block-equations {\n     font-family: var(--t5-font-mono);\n     font-size: 11px;\n     color: var(--t5-text-mid);\n     background: var(--t5-panel);\n     padding: 12px;\n     border-radius: var(--t5-radius-md);\n   }\n   \n   .cre5-block-equations .katex-display {\n     margin: 0.5em 0;\n   }\n   \n   /* ─── Two Steps Diagram ─────────────────────────────────────── */\n   .cre5-two-steps-container {\n     background: var(--t5-surface);\n     border-radius: var(--t5-radius-lg);\n     padding: 24px;\n     margin: 24px 0;\n     border: 1px solid var(--t5-border-light);\n   }\n   \n   .cre5-two-steps-diagram {\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     gap: 16px;\n     flex-wrap: wrap;\n   }\n   \n   .cre5-step-box {\n     flex: 1;\n     min-width: 180px;\n     padding: 20px;\n     border-radius: var(--t5-radius-md);\n     text-align: center;\n   }\n   \n   .cre5-step-box--rate {\n     background: var(--t5-cyan-dim);\n     border: 2px solid var(--t5-cyan);\n   }\n   \n   .cre5-step-box--stoich {\n     background: var(--t5-blue-dim);\n     border: 2px solid var(--t5-blue);\n   }\n   \n   .cre5-step-box--combine {\n     background: var(--t5-accent-dim);\n     border: 2px solid var(--t5-accent);\n   }\n   \n   .cre5-step-box-title {\n     font-family: var(--t5-font-mono);\n     font-size: 12px;\n     font-weight: 600;\n     margin-bottom: 12px;\n   }\n   \n   .cre5-step-box--rate .cre5-step-box-title { color: var(--t5-cyan); }\n   .cre5-step-box--stoich .cre5-step-box-title { color: var(--t5-blue); }\n   .cre5-step-box--combine .cre5-step-box-title { color: var(--t5-accent); }\n   \n   .cre5-step-box-eq {\n     font-family: var(--t5-font-mono);\n     font-size: 14px;\n     margin: 12px 0;\n     padding: 8px;\n     background: rgba(255,255,255,0.5);\n     border-radius: var(--t5-radius-sm);\n   }\n   \n   .cre5-step-box-desc {\n     font-size: 12px;\n     color: var(--t5-text-dim);\n   }\n   \n   .cre5-step-arrow {\n     font-size: 28px;\n     color: var(--t5-text-mid);\n     font-weight: bold;\n   }\n   \n   @media (max-width: 700px) {\n     .cre5-two-steps-diagram { flex-direction: column; }\n     .cre5-step-arrow { transform: rotate(90deg); }\n   }\n   \n   /* ─── Reactors Diagram ──────────────────────────────────────── */\n   .cre5-reactors-diagram {\n     display: flex;\n     justify-content: center;\n     gap: 32px;\n     margin: 24px 0;\n     padding: 20px;\n     background: var(--t5-surface);\n     border-radius: var(--t5-radius-lg);\n     border: 1px solid var(--t5-border-light);\n     flex-wrap: wrap;\n   }\n   \n   .cre5-reactor-icon {\n     text-align: center;\n   }\n   \n   .cre5-reactor-icon svg {\n     display: block;\n     margin: 0 auto;\n   }\n   \n   /* ─── Arrhenius Plot ────────────────────────────────────────── */\n   .cre5-arrhenius-container {\n     background: var(--t5-surface);\n     border-radius: var(--t5-radius-lg);\n     padding: 24px;\n     margin: 24px 0;\n     border: 1px solid var(--t5-border-light);\n   }\n   \n   .cre5-arrhenius-title {\n     font-family: var(--t5-font-mono);\n     font-size: 11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color: var(--t5-text-dim);\n     margin-bottom: 16px;\n     text-align: center;\n   }\n   \n   .cre5-arrhenius-svg {\n     width: 100%;\n     max-width: 500px;\n     display: block;\n     margin: 0 auto;\n   }\n   \n   .cre5-arrhenius-caption {\n     font-size: 12px;\n     color: var(--t5-text-sub);\n     text-align: center;\n     margin-top: 14px;\n     font-style: italic;\n   }\n   \n   /* ─── Stoichiometry Table Visual ─────────────────────────────── */\n   .cre5-stoich-table-visual {\n     background: var(--t5-surface);\n     border-radius: var(--t5-radius-lg);\n     border: 1px solid var(--t5-border);\n     overflow: hidden;\n     margin: 24px 0;\n   }\n   \n   .cre5-stoich-row {\n     display: grid;\n     grid-template-columns: 80px 1fr 1fr 1.5fr;\n     border-bottom: 1px solid var(--t5-border-light);\n   }\n   \n   .cre5-stoich-row > span {\n     padding: 12px 16px;\n     font-size: 13px;\n   }\n   \n   .cre5-stoich-header {\n     background: var(--t5-panel);\n     font-family: var(--t5-font-mono);\n     font-size: 10px;\n     text-transform: uppercase;\n     letter-spacing: 1px;\n     font-weight: 600;\n     color: var(--t5-text-dim);\n   }\n   \n   .cre5-stoich-header > span {\n     padding: 10px 16px;\n   }\n   \n   .cre5-stoich-species {\n     font-family: var(--t5-font-mono);\n     font-weight: 600;\n     color: var(--t5-text-mid);\n   }\n   \n   .cre5-stoich-result {\n     font-family: var(--t5-font-mono);\n     color: var(--t5-accent);\n     font-weight: 500;\n   }\n   \n   .cre5-stoich-total {\n     background: var(--t5-accent-dim);\n     border-top: 1px solid var(--t5-border);\n   }\n   \n   @media (max-width: 800px) {\n     .cre5-stoich-row {\n       grid-template-columns: 60px 1fr 1fr 1fr;\n       font-size: 11px;\n     }\n     .cre5-stoich-row > span { padding: 8px 12px; }\n   }\n   \n   /* ─── Table styles ──────────────────────────────────────────── */\n   .cre5-table {\n     width: 100%;\n     border-collapse: collapse;\n     margin: 16px 0;\n     font-size: 13px;\n     background: var(--t5-surface);\n     border-radius: var(--t5-radius-md);\n     overflow: hidden;\n     border: 1px solid var(--t5-border-light);\n   }\n   \n   .cre5-table thead {\n     background: var(--t5-panel);\n   }\n   \n   .cre5-table th {\n     padding: 11px 14px;\n     text-align: left;\n     font-family: var(--t5-font-mono);\n     font-size: 10px;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n     color: var(--t5-text-dim);\n     border-bottom: 1px solid var(--t5-border);\n     font-weight: 600;\n   }\n   \n   .cre5-table td {\n     padding: 12px 14px;\n     border-bottom: 1px solid var(--t5-border-light);\n     color: var(--t5-text-muted);\n     vertical-align: top;\n   }\n   \n   .cre5-symbols-table {\n     width: 100%;\n     border-collapse: collapse;\n     margin: 20px 0;\n     font-size: 13px;\n     background: var(--t5-surface);\n     border-radius: var(--t5-radius-md);\n     overflow: hidden;\n     border: 1px solid var(--t5-border-light);\n   }\n   \n   .cre5-symbols-table thead {\n     background: var(--t5-panel);\n   }\n   \n   .cre5-symbols-table th {\n     padding: 11px 14px;\n     text-align: left;\n     font-family: var(--t5-font-mono);\n     font-size: 10px;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n     color: var(--t5-text-dim);\n     border-bottom: 1px solid var(--t5-border);\n     font-weight: 600;\n   }\n   \n   .cre5-symbols-table td {\n     padding: 12px 14px;\n     border-bottom: 1px solid var(--t5-border-light);\n     color: var(--t5-text-muted);\n   }\n   \n   /* ─── Definition cards ──────────────────────────────────────── */\n   .cre5-definitions-grid {\n     display: grid;\n     grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n     gap: 16px;\n     margin-top: 20px;\n   }\n   \n   .cre5-def-card {\n     background: var(--t5-surface);\n     border: 1px solid var(--t5-border);\n     border-radius: var(--t5-radius-md);\n     padding: 16px;\n     transition: all 0.2s ease;\n   }\n   \n   .cre5-def-card:hover {\n     box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n   }\n   \n   .cre5-def-title {\n     font-family: var(--t5-font-serif);\n     font-size: 13px;\n     font-weight: 600;\n     color: var(--t5-text);\n     margin-bottom: 10px;\n   }\n   \n   /* ─── Callout boxes ─────────────────────────────────────────── */\n   .cre5-callout {\n     border-radius: var(--t5-radius-md);\n     padding:       14px 18px;\n     margin:        18px 0;\n     font-size:     14px;\n     line-height:   1.65;\n   }\n   .cre5-callout p  { color: var(--t5-text-muted); margin: 0; }\n   .cre5-callout--key  { background: var(--t5-blue-dim);  border: 1px solid var(--t5-blue-border);  }\n   .cre5-callout--info { background: var(--t5-cyan-dim);  border: 1px solid var(--t5-cyan-border);  }\n   .cre5-callout--rate { background: var(--t5-blue-dim); border: 1px solid var(--t5-blue-border); }\n   \n   /* ─── Equation boxes ────────────────────────────────────────── */\n   .cre5-equation-box {\n     background:    var(--t5-eq-bg);\n     border:        1px solid var(--t5-border-light);\n     border-left:   3px solid var(--t5-amber);\n     border-radius: var(--t5-radius-md);\n     padding:       18px 22px;\n     margin:        18px 0;\n     overflow-x:    auto;\n   }\n   \n   .cre5-equation-box--primary {\n     border-left-color: var(--t5-accent);\n   }\n   \n   .cre5-equation-box--flow {\n     border-left-color: var(--t5-blue);\n   }\n   \n   .cre5-equation-box--gas {\n     border-left-color: var(--t5-cyan);\n   }\n   \n   .cre5-equation-box--compare {\n     border-left-color: var(--t5-amber);\n   }\n   \n   .cre5-eq-label {\n     font-size:      10px;\n     font-family:    var(--t5-font-mono);\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t5-text-dim);\n     margin-bottom:  8px;\n   }\n   \n   /* ─── Example box ───────────────────────────────────────────── */\n   .cre5-example-box {\n     background: var(--t5-surface);\n     border: 1px solid var(--t5-border);\n     border-radius: var(--t5-radius-md);\n     padding: 20px;\n     margin: 16px 0;\n   }\n   \n   .cre5-example-header {\n     font-family: var(--t5-font-serif);\n     font-size: 14px;\n     font-weight: 600;\n     color: var(--t5-text);\n     padding-bottom: 12px;\n     border-bottom: 1px solid var(--t5-border-light);\n   }\n   \n   /* ─── Reactor cards ─────────────────────────────────────────── */\n   .cre5-reactor-cards {\n     display: grid;\n     grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n     gap: 20px;\n     margin-top: 20px;\n   }\n   \n   .cre5-reactor-card {\n     background: var(--t5-surface);\n     border: 1px solid var(--t5-border);\n     border-radius: var(--t5-radius-md);\n     padding: 16px;\n     transition: all 0.2s ease;\n   }\n   \n   .cre5-reactor-card:hover {\n     box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n   }\n   \n   .cre5-reactor-card--batch {\n     border-top: 3px solid var(--t5-batch);\n   }\n   \n   .cre5-reactor-card--cstr {\n     border-top: 3px solid var(--t5-cstr);\n   }\n   \n   .cre5-reactor-card--pfr {\n     border-top: 3px solid var(--t5-pfr);\n   }\n   \n   .cre5-reactor-card--pbr {\n     border-top: 3px solid var(--t5-pbr);\n   }\n   \n   .cre5-card-title {\n     font-family: var(--t5-font-serif);\n     font-size: 14px;\n     font-weight: 600;\n     color: var(--t5-text);\n     margin-bottom: 12px;\n   }\n   \n   .cre5-card-eq {\n     background: var(--t5-panel);\n     padding: 12px;\n     border-radius: var(--t5-radius-sm);\n     margin-bottom: 12px;\n     font-size: 12px;\n   }\n   \n   .cre5-card-info {\n     font-size: 12px;\n     color: var(--t5-text-muted);\n   }\n   \n   .cre5-card-info ul {\n     margin-left: 16px;\n     margin-top: 8px;\n   }\n   \n   .cre5-card-info li {\n     margin-bottom: 6px;\n     line-height: 1.5;\n   }\n   \n   /* ─── Section styles ────────────────────────────────────────── */\n   .cre5-section {\n     margin-bottom: var(--t5-space-2xl);\n     scroll-margin-top: 24px;\n   }\n   \n   .cre5-section-label {\n     font-family:    var(--t5-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2.5px;\n     color:          var(--t5-text-sub);\n     margin-bottom:  6px;\n   }\n   \n   .cre5-section h2 {\n     font-family:   var(--t5-font-serif);\n     font-size:     26px;\n     font-weight:   700;\n     color:         var(--t5-text);\n     margin-bottom: 6px;\n     line-height:   1.3;\n   }\n   \n   .cre5-section-divider {\n     width:         40px;\n     height:        3px;\n     background:    var(--t5-accent);\n     margin-bottom: 22px;\n     border-radius: 2px;\n   }\n   \n   .cre5-section p {\n     margin-bottom: 14px;\n     color:         var(--t5-text-muted);\n     line-height:   1.75;\n   }\n   \n   /* ─── Badges ────────────────────────────────────────────────── */\n   .cre5-lec-badge {\n     display:        inline-block;\n     font-family:    var(--t5-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     padding:        3px 9px;\n     border-radius:  var(--t5-radius-sm);\n     margin-bottom:  10px;\n     font-weight:    500;\n   }\n   \n   .cre5-lec-badge--foundation {\n     background: var(--t5-green-dim);\n     color:      var(--t5-accent);\n     border:     1px solid var(--t5-green-border);\n   }\n   .cre5-lec-badge--block1 {\n     background: rgba(216, 159, 58, 0.10);\n     color:      var(--t5-amber);\n     border:     1px solid var(--t5-amber-border);\n   }\n   .cre5-lec-badge--block2 {\n     background: var(--t5-cyan-dim);\n     color:      var(--t5-cyan);\n     border:     1px solid var(--t5-cyan-border);\n   }\n   .cre5-lec-badge--block3 {\n     background: var(--t5-blue-dim);\n     color:      var(--t5-blue);\n     border:     1px solid var(--t5-blue-border);\n   }\n   .cre5-lec-badge--equilibrium {\n     background: var(--t5-accent-dim);\n     color:      var(--t5-accent);\n     border:     1px solid var(--t5-green-border);\n   }\n   \n   /* ─── Footer ────────────────────────────────────────────────── */\n   .cre5-footer {\n     border-top:  1px solid var(--t5-border-light);\n     padding-top: 24px;\n     margin-top:  40px;\n     color:       var(--t5-text-dim);\n     font-family: var(--t5-font-mono);\n     font-size:   11px;\n     text-align: center;\n   }\n   \n   /* ─── Animation ─────────────────────────────────────────────── */\n   @keyframes fadeIn5 {\n     from { opacity: 0; transform: translateY(4px); }\n     to   { opacity: 1; transform: translateY(0); }\n   }\n   \n   /* ─── Katex overrides ───────────────────────────────────────── */\n   .katex { font-size: 1.05em; }\n   .katex-display { margin: 0.8em 0; overflow-x: auto; overflow-y: hidden; }\n   \n   /* ─── Responsive ────────────────────────────────────────────── */\n   @media (max-width: 1200px) {\n     .cre5-main-inner { padding: 36px 36px 60px; }\n   }\n   \n   @media (max-width: 900px) {\n     .cre5-sidebar { display: none !important; }\n     .cre5-main-inner { padding: 24px 20px 60px; }\n     .cre5-toc-grid { grid-template-columns: 1fr 1fr; }\n     .cre5-blocks-diagram { grid-template-columns: 1fr; }\n   }\n   \n   @media (max-width: 600px) {\n     .cre5-hero h1 { font-size: 26px; }\n     .cre5-toc-grid { grid-template-columns: 1fr; }\n     .cre5-definitions-grid { grid-template-columns: 1fr; }\n     .cre5-reactor-cards { grid-template-columns: 1fr; }\n     .cre5-reactors-diagram { gap: 16px; }\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
